import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import TransactionService from "../../services/TransactionService";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import QuotationComponent from "../../components/QuotationComponent";
import {Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TransactionRequiredFieldsComponent from "../../components/TransactionRequiredFieldsComponent";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import TransactionRequest from "../../domain/TransactionRequest";
import QuotationResponseComponent from "../../components/QuotationResponseComponent";
import TransactionCompleteCard from "../../components/TransactionCompleteCard";

const DECLARATION_LINK = process.env.REACT_APP_DECLARATION_LINK;
const T_AND_C_LINK = process.env.REACT_APP_T_AND_C_LINK;


const QUOTATION_REQUEST = "quotation request";
const QUOTATION_RESPONSE = "quotation response";
const BENEFICIARY_DETAILS = "beneficiary details";
const TRANSACTION_DETAILS = "transaction details";

class TransactionCreation extends React.Component {

    constructor(props) {
        super(props);

        this.quotationRef = null;
        this.requiredFieldsRef = null;

        this.registrationId = this.props.match.params.registrationId;

        this.state = {
            currentTab: QUOTATION_REQUEST,

            quotationResponse: null,
            transactionRequest: null,
            transactionResponse: null,

            loading: false,
            requiredFieldsValid: false,

            showTransactionCompleteModal: false,
            showErrorModal: false,
            quotationErrors: []
        };

        this.retrieveQuotationResponse = this.retrieveQuotationResponse.bind(this);
        this.requiredFieldsValid = this.requiredFieldsValid.bind(this);
    }

    retrieveQuotationResponse = (quotationRequest, quotationResponse) => {

        this.setState({
            quotationResponse: quotationResponse,
            currentTab: QUOTATION_RESPONSE
        })
    };

    requiredFieldsValid = isValid => {
        this.setState({
            requiredFieldsValid: isValid
        })
    };

    generateTransactionRequest() {

        let beneficiaryDetails = this.requiredFieldsRef.getValues();

        let transactionRequest = TransactionRequest.create(
            this.state.quotationResponse.quotationReference,
            this.registrationId,
            beneficiaryDetails["captured-fields"],
            beneficiaryDetails["save-beneficiary"]
        );

        this.setState({
            transactionRequest: transactionRequest,
            loading: true
        }, () => this.createTransaction(transactionRequest))
    }

    createTransaction(transactionRequest) {

        TransactionService.createTransaction(transactionRequest).then(response => {
            if (response["error-code"]) {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    quotationErrors: response
                })
            } else {
                this.setState({
                    transactionResponse: response,
                    currentTab: TRANSACTION_DETAILS,
                    loading: false
                })
            }
        })
    }

    backToQuoteButtonClick(){
        this.setState({
            currentTab: QUOTATION_RESPONSE
        })
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}

        </Fragment>
    }

    renderContent(className) {

        return <Fragment>

            {this.renderQuotationExpiredModal(className)}

            {this.state.currentTab === QUOTATION_REQUEST && this.renderQuotationRequest(className)}
            {this.state.currentTab === QUOTATION_RESPONSE && (className === 'mobile' ? this.renderQuotationResponse(className) : this.renderBrowserQuotationResponse(className))}
            {this.state.currentTab === BENEFICIARY_DETAILS && (className === 'mobile' ? this.renderBeneficiaryDetails(className) : this.renderBrowserBeneficiaryDetails(className))}
            {this.state.currentTab === TRANSACTION_DETAILS && this.renderTransactionDetails(className)}

        </Fragment>

    }

    renderQuotationRequest(className) {
        return <Fragment>

            <QuotationComponent
                registrationId={this.registrationId}
                quotationRef={ref => this.quotationRef = ref}
                className={className}
                returnQuotationResponse={this.retrieveQuotationResponse}
                btnBackClick={this.props.btnBackClick}
            />

        </Fragment>

    }

    renderQuotationResponse(className) {
        let bopDescription = ""
        if (this.state.quotationResponse.bopCategory !== "") {
            bopDescription = " as BOP Code " + this.state.quotationResponse.bopCategory.reportingCode + " - " + this.state.quotationResponse.bopCategory.outboundDescription;
        }
        return <Fragment>

            <QuotationResponseComponent
                className={className}
                quotationResponse={this.state.quotationResponse}
            />

            <hr />

            <div style={{fontWeight: "bold"}}>
            By acceptance of this quotation, you are confirming your transaction will be reported
            {bopDescription}. For more information, please view the
            <a href={DECLARATION_LINK}
            target="_blank" rel="noopener noreferrer"> Declaration </a>and
            <a href={T_AND_C_LINK}
            target="_blank" rel="noopener noreferrer"> Terms and Conditions</a>
            </div>

            <hr />

            {this.renderAcceptQuoteButton(className)}
            {this.renderNewQuoteButton(className)}

        </Fragment>
    }

    renderBrowserQuotationResponse(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderQuotationResponse(className)}
        </Card>
    }

    renderBeneficiaryDetails(className) {

        return <Fragment>

            <TransactionRequiredFieldsComponent
                registerRef={ref => {
                    this.requiredFieldsRef = ref
                }}
                className={className}
                requiredFields={this.props.beneficiaryRequiredFields === undefined ? this.state.quotationResponse.requiredFields : this.props.beneficiaryRequiredFields}
                isValid={this.requiredFieldsValid}
            />

            {this.renderRequiredFieldButtons(className)}

        </Fragment>
    }

    renderBrowserBeneficiaryDetails(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderBeneficiaryDetails(className)}
        </Card>
    }

    renderTransactionDetails(className) {
        return <Fragment>

            <TransactionCompleteCard
                className={className}
                transaction={this.state.transactionResponse}
                btnBackClick={this.props.btnBackClick}
            />
        </Fragment>

    }

    renderAcceptQuoteButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={"btn-primary"}
                onClick={() => this.setState({currentTab: BENEFICIARY_DETAILS})}
            >Accept
            </SFXButtonComponent>
        </div>
    }

    renderNewQuoteButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_grey_oval_button"}
                onClick={() => this.setState({currentTab: QUOTATION_REQUEST})}
            >New Quote
            </SFXButtonComponent>
        </div>
    }

    renderRequiredFieldButtons(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent className={"btn-secondary"}
                                onClick={this.backToQuoteButtonClick.bind(this)}>
                Back
            </SFXButtonComponent>
            {'  '}
            <SFXButtonComponent
                className={"btn-primary"}
                onClick={() => this.generateTransactionRequest()}
                disabled={!this.state.requiredFieldsValid}
            >Complete
            </SFXButtonComponent>
        </div>
    }

    renderQuotationExpiredModal(className) {

        return <Modal isOpen={this.state.showErrorModal} style={{borderRadius: " 25px"}}>

            <ModalHeader className={className + "_modal_header"}>{this.state.quotationErrors["message"]}</ModalHeader>
            <ModalBody>{this.state.quotationErrors["errors"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false,
                        currentTab: QUOTATION_REQUEST
                    })}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }
}

export default withRouter(TransactionCreation);